import { useCallback, useMemo } from 'react';

/**
 * Manages sorting state for interaction tables
 *
 * Handles FlexTable sorting by converting between API sort format and
 * FlexTable's sort model format. Provides callbacks for sort changes.
 */
export const useInteractionSorting = ({ sortProp = '', sortReverse = false, onSort = () => {} }) => {
  const sortModel = useMemo(() => {
    return [
      {
        field: sortProp,
        sort: sortReverse ? 'desc' : 'asc',
      },
    ];
  }, [sortProp, sortReverse]);

  const handleSortModelChange = useCallback(
    (newModel) => {
      if (newModel.length === 0) return;

      const { field, sort } = newModel[0];
      const reverse = sort === 'desc';

      onSort(field, reverse);
    },
    [onSort]
  );

  return {
    sortModel,
    handleSortModelChange,
  };
};
